import React from "react";

export default function PhoneMockup({ children, className = "" }) {
  return (
    <div className={`relative mx-auto ${className}`} style={{ width: 300 }}>
      <div className="relative rounded-[2.6rem] border-[10px] border-neutral-900 bg-neutral-900 shadow-2xl" style={{ height: 600 }}>
        <div className="absolute left-1/2 -translate-x-1/2 top-0 h-6 w-32 bg-neutral-900 rounded-b-2xl z-20" />
        <div className="h-full w-full overflow-hidden rounded-[2rem] bg-background">
          <div className="h-full w-full overflow-y-auto no-scrollbar">{children}</div>
        </div>
      </div>
    </div>
  );
}
